import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import organisationSettingConstants from "./../Constants/OrganisationSettingConstants";

let result = null;
let settingUpdateRes = null;
let addDemoData = null;
let paritaldelResult = null;
let fulldelResult = null;
class OrganisationSettingStore extends EventEmitter {
  getOrgSettingResult() {
    return result;
  }
  setOrgSettingResult(res) {
    result = res;
  }

  getOrgSettingUpdateResult() {
    return settingUpdateRes;
  }
  setOrgSettingUpdateResult(res) {
    settingUpdateRes = res;
  }

  getAddDemoDataResult() {
    return addDemoData;
  }
  setAddDemoDataResult(res) {
    addDemoData = res;
  }

  getPartialDelResult() {
    return paritaldelResult;
  }
  setPartialDelResult(res) {
    paritaldelResult = res;
  }

  getfullDelResult() {
    return fulldelResult;
  }

  setfullDelResult(res) {
    fulldelResult = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case organisationSettingConstants.GET_ORG_SETTING_SUCCESS:
        this.setOrgSettingResult(action.result);
        break;
      case organisationSettingConstants.GET_ORG_SETTING_FAILURE:
        this.setOrgSettingResult(action.result);
        break;
      case organisationSettingConstants.UPDATE_ORG_SETTING_SUCCESS:
        this.setOrgSettingUpdateResult(action.result);
        break;
      case organisationSettingConstants.UPDATE_ORG_SETTING_FAILURE:
        this.setOrgSettingUpdateResult(action.result);
        break;
      case organisationSettingConstants.ADD_ORG_DATA_SETTING_SUCCESS:
        this.setAddDemoDataResult(action.result);
        break;
      case organisationSettingConstants.ADD_ORG_DATA_SETTING_FAILURE:
        this.setAddDemoDataResult(action.result);
        break;
      case organisationSettingConstants.PARITAL_DEL_ORG_SETTING_SUCCESS:
        this.setPartialDelResult(action.result);
        break;
      case organisationSettingConstants.PARITAL_DEL_ORG_SETTING_FAILURE:
        this.setPartialDelResult(action.result);
        break;
      case organisationSettingConstants.FULL_DEL_ORG_SETTING_SUCCESS:
        this.setfullDelResult(action.result);
        break;
      case organisationSettingConstants.FULL_DEL_ORG_SETTING_FAILURE:
        this.setfullDelResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const organisationSettingStore = new OrganisationSettingStore();
dispatcher.register(
  organisationSettingStore.handleCallback.bind(organisationSettingStore)
);
export default organisationSettingStore;
